var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1925_2886)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1925_2886",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1925_2886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3 0H18.6667V5.41667H-3V0Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3 5.41675H18.6667V10.8334H-3V5.41675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3 10.8333H18.6667V16.2499H-3V10.8333Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83366 10.2916C9.03028 10.2916 10.0003 9.32154 10.0003 8.12492C10.0003 6.9283 9.03028 5.95825 7.83366 5.95825C6.63704 5.95825 5.66699 6.9283 5.66699 8.12492C5.66699 9.32154 6.63704 10.2916 7.83366 10.2916Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83333 10.0207C8.88037 10.0207 9.72917 9.17188 9.72917 8.12484C9.72917 7.0778 8.88037 6.229 7.83333 6.229C6.78629 6.229 5.9375 7.0778 5.9375 8.12484C5.9375 9.17188 6.78629 10.0207 7.83333 10.0207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83327 8.50418C8.04268 8.50418 8.21243 8.33442 8.21243 8.12502C8.21243 7.91561 8.04268 7.74585 7.83327 7.74585C7.62386 7.74585 7.4541 7.91561 7.4541 8.12502C7.4541 8.33442 7.62386 8.50418 7.83327 8.50418Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70012 8.46973C9.75351 8.47676 9.80248 8.43918 9.80951 8.38579C9.81654 8.3324 9.77896 8.28343 9.72557 8.2764C9.67219 8.26937 9.62321 8.30695 9.61618 8.36034C9.60915 8.41372 9.64673 8.4627 9.70012 8.46973Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83355 10.0207L7.89855 8.88322L7.83355 8.34155L7.76855 8.88322L7.83355 10.0207Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54768 8.94135C9.59743 8.96195 9.65446 8.93833 9.67507 8.88858C9.69568 8.83883 9.67205 8.7818 9.6223 8.76119C9.57256 8.74058 9.51552 8.76421 9.49491 8.81396C9.47431 8.8637 9.49793 8.92074 9.54768 8.94135Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34303 9.95616L7.70022 8.87424L7.77763 8.33421L7.57465 8.84059L7.34303 9.95616Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27798 9.35712C9.3207 9.38991 9.38191 9.38185 9.41469 9.33913C9.44747 9.29641 9.43941 9.2352 9.39669 9.20242C9.35397 9.16964 9.29276 9.1777 9.25998 9.22042C9.2272 9.26314 9.23526 9.32434 9.27798 9.35712Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88565 9.76673L7.5107 8.81413L7.72524 8.31253L7.39811 8.74913L6.88565 9.76673Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90953 9.68874C8.94231 9.73146 9.00352 9.73951 9.04624 9.70673C9.08896 9.67395 9.09702 9.61275 9.06424 9.57003C9.03146 9.52731 8.97025 9.51925 8.92753 9.55203C8.88481 9.58481 8.87675 9.64602 8.90953 9.68874Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4924 9.46549L7.3427 8.70712L7.67975 8.27814L7.25077 8.61519L6.4924 9.46549Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46848 9.91421C8.48909 9.96396 8.54612 9.98759 8.59587 9.96698C8.64562 9.94637 8.66925 9.88934 8.64864 9.83959C8.62803 9.78984 8.571 9.76622 8.52125 9.78682C8.4715 9.80743 8.44788 9.86446 8.46848 9.91421Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19158 9.07288L7.20918 8.56042L7.64578 8.23329L7.14418 8.44784L6.19158 9.07288Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98346 10.0174C7.99049 10.0708 8.03946 10.1084 8.09285 10.1013C8.14624 10.0943 8.18382 10.0453 8.17679 9.99193C8.16976 9.93854 8.12078 9.90096 8.0674 9.90799C8.01401 9.91502 7.97643 9.964 7.98346 10.0174Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00229 8.61579L7.11786 8.38417L7.62425 8.18119L7.08421 8.2586L6.00229 8.61579Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48925 9.99187C7.48223 10.0453 7.51981 10.0942 7.57319 10.1013C7.62658 10.1083 7.67556 10.0707 7.68259 10.0173C7.68961 9.96393 7.65203 9.91496 7.59865 9.90793C7.54526 9.9009 7.49628 9.93848 7.48925 9.99187Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93802 8.12506L7.07552 8.19006L7.61719 8.12506L7.07552 8.06006L5.93802 8.12506Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01788 9.83894C6.99728 9.88869 7.0209 9.94572 7.07065 9.96633C7.1204 9.98694 7.17743 9.96331 7.19804 9.91356C7.21865 9.86382 7.19502 9.80678 7.14527 9.78617C7.09552 9.76557 7.03849 9.78919 7.01788 9.83894Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00283 7.63429L7.08475 7.99148L7.62478 8.06889L7.11839 7.86591L6.00283 7.63429Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60137 9.56924C6.56859 9.61196 6.57665 9.67316 6.61937 9.70595C6.66209 9.73873 6.7233 9.73067 6.75608 9.68795C6.78886 9.64523 6.7808 9.58402 6.73808 9.55124C6.69536 9.51846 6.63415 9.52652 6.60137 9.56924Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19201 7.17691L7.14461 7.80196L7.64621 8.0165L7.20961 7.68937L6.19201 7.17691Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26976 9.20128C6.22704 9.23406 6.21898 9.29527 6.25176 9.33799C6.28454 9.38071 6.34575 9.38877 6.38847 9.35599C6.43119 9.3232 6.43925 9.262 6.40647 9.21928C6.37369 9.17656 6.31248 9.1685 6.26976 9.20128Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.49325 6.78464L7.25162 7.63493L7.6806 7.97199L7.34355 7.54301L6.49325 6.78464Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04428 8.75999C5.99453 8.78059 5.97091 8.83763 5.99152 8.88738C6.01212 8.93713 6.06916 8.96075 6.11891 8.94014C6.16865 8.91954 6.19228 8.8625 6.17167 8.81275C6.15107 8.763 6.09403 8.73938 6.04428 8.75999Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88538 6.48333L7.39783 7.50093L7.72496 7.93753L7.51042 7.43593L6.88538 6.48333Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94136 8.27521C5.88797 8.28223 5.85039 8.33121 5.85742 8.3846C5.86445 8.43798 5.91342 8.47557 5.96681 8.46854C6.0202 8.46151 6.05778 8.41253 6.05075 8.35914C6.04372 8.30576 5.99475 8.26818 5.94136 8.27521Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34246 6.2938L7.57408 7.40936L7.77706 7.91575L7.69965 7.37572L7.34246 6.2938Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96687 7.78027C5.91349 7.77324 5.86451 7.81082 5.85748 7.86421C5.85045 7.9176 5.88803 7.96657 5.94142 7.9736C5.99481 7.98063 6.04378 7.94305 6.05081 7.88966C6.05784 7.83628 6.02026 7.7873 5.96687 7.78027Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83344 6.22928L7.76844 7.36678L7.83344 7.90845L7.89844 7.36678L7.83344 6.22928Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11931 7.30865C6.06956 7.28805 6.01253 7.31167 5.99192 7.36142C5.97131 7.41117 5.99494 7.4682 6.04469 7.48881C6.09444 7.50942 6.15147 7.48579 6.17208 7.43604C6.19268 7.3863 6.16906 7.32926 6.11931 7.30865Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32396 6.29384L7.96677 7.37576L7.88936 7.91579L8.09234 7.40941L8.32396 6.29384Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38901 6.89288C6.34629 6.86009 6.28509 6.86815 6.25231 6.91087C6.21953 6.95359 6.22758 7.0148 6.2703 7.04758C6.31302 7.08036 6.37423 7.0723 6.40701 7.02958C6.43979 6.98686 6.43173 6.92566 6.38901 6.89288Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78134 6.48327L8.1563 7.43587L7.94176 7.93747L8.26888 7.50087L8.78134 6.48327Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75746 6.56126C6.72468 6.51854 6.66347 6.51049 6.62075 6.54327C6.57803 6.57605 6.56997 6.63725 6.60276 6.67997C6.63554 6.72269 6.69674 6.73075 6.73946 6.69797C6.78218 6.66519 6.79024 6.60398 6.75746 6.56126Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17361 6.78451L8.32332 7.54288L7.98626 7.97186L8.41524 7.63481L9.17361 6.78451Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19851 6.33579C7.1779 6.28604 7.12087 6.26241 7.07112 6.28302C7.02137 6.30363 6.99775 6.36066 7.01835 6.41041C7.03896 6.46016 7.09599 6.48378 7.14574 6.46318C7.19549 6.44257 7.21912 6.38554 7.19851 6.33579Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47541 7.17712L8.45781 7.68958L8.02121 8.01671L8.52281 7.80216L9.47541 7.17712Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68354 6.23262C7.67651 6.17923 7.62753 6.14165 7.57414 6.14868C7.52076 6.15571 7.48317 6.20468 7.4902 6.25807C7.49723 6.31146 7.54621 6.34904 7.5996 6.34201C7.65298 6.33498 7.69056 6.286 7.68354 6.23262Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6647 7.63421L8.54913 7.86583L8.04275 8.06881L8.58278 7.9914L9.6647 7.63421Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17774 6.25813C8.18477 6.20475 8.14719 6.15577 8.0938 6.14874C8.04041 6.14171 7.99143 6.17929 7.98441 6.23268C7.97738 6.28607 8.01496 6.33504 8.06835 6.34207C8.12173 6.3491 8.17071 6.31152 8.17774 6.25813Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72897 8.12494L8.59147 8.05994L8.0498 8.12494L8.59147 8.18994L9.72897 8.12494Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64911 6.41106C8.66972 6.36131 8.64609 6.30428 8.59634 6.28367C8.54659 6.26306 8.48956 6.28669 8.46895 6.33644C8.44835 6.38618 8.47197 6.44322 8.52172 6.46383C8.57147 6.48443 8.6285 6.46081 8.64911 6.41106Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66416 8.61571L8.58225 8.25852L8.04221 8.18111L8.5486 8.38409L9.66416 8.61571Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06562 6.68076C9.0984 6.63804 9.09034 6.57684 9.04762 6.54405C9.0049 6.51127 8.9437 6.51933 8.91092 6.56205C8.87814 6.60477 8.88619 6.66598 8.92891 6.69876C8.97163 6.73154 9.03284 6.72348 9.06562 6.68076Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47498 9.07309L8.52238 8.44804L8.02078 8.2335L8.45738 8.56063L9.47498 9.07309Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39723 7.04872C9.43995 7.01594 9.44801 6.95473 9.41523 6.91201C9.38245 6.86929 9.32124 6.86123 9.27852 6.89401C9.2358 6.9268 9.22775 6.988 9.26053 7.03072C9.29331 7.07344 9.35451 7.0815 9.39723 7.04872Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17374 9.46536L8.41537 8.61507L7.98639 8.27801L8.32345 8.70699L9.17374 9.46536Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.62271 7.49026C9.67246 7.46965 9.69608 7.41262 9.67548 7.36287C9.65487 7.31312 9.59783 7.28949 9.54809 7.3101C9.49834 7.33071 9.47471 7.38774 9.49532 7.43749C9.51593 7.48724 9.57296 7.51086 9.62271 7.49026Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78162 9.76667L8.26916 8.74907L7.94203 8.31247L8.15658 8.81407L8.78162 9.76667Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72563 7.97479C9.77902 7.96777 9.8166 7.91879 9.80957 7.8654C9.80255 7.81202 9.75357 7.77443 9.70018 7.78146C9.64679 7.78849 9.60921 7.83747 9.61624 7.89086C9.62327 7.94424 9.67225 7.98182 9.72563 7.97479Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32453 9.9562L8.09291 8.84064L7.88993 8.33425L7.96734 8.87428L8.32453 9.9562Z",
    fill: "#000088"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1925_2886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.7dd38e556b82465a6ee18b27715381ab.svg";
export { ForwardRef as ReactComponent };